import { isProdBuild } from '../../i18n/environments';
import { abTestingAPI, ABTestingEncrypt } from '../../i18n/environments';
import CryptoJS from 'crypto-js';

export const encryptPayload = (payload) => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.enc.Base64.parse(ABTestingEncrypt);

  payload = {
    ...payload,
    api_key: process.env.REACT_APP_API_KEY,
  };

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), key, { iv });

  return {
    encryptedKey: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
    iv: CryptoJS.enc.Base64.stringify(iv),
  };
};

export const sendUserIdToDB = async (payload) => {
  try {
    const encryptedBody = encryptPayload(payload);
    const body = {
      ...encryptedBody,
    };
    const response = await fetch(abTestingAPI, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    sessionStorage.removeItem('lst');

    if (!response.ok) {
      console.error(response);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Request failed', error);
  }
};

export const testsToTrack = [
  {
    id: isProdBuild ? 'ee38ccbc-dc7d-4557-81c0-5447b2848af0' : 'ad4ec14b-2ab7-4c0a-9ad7-23824e1337f8',
    versions: ['IntroA', 'IntroB'],
  },
  {
    id: isProdBuild ? '8d1656b0-8d5b-4074-bb5f-bd36b8cc32c1' : '0a9526d2-f5fb-4fbc-911d-89b918afa60f',
    versions: ['FreeEmailVerifierA', 'FreeEmailVerifierB'],
  },
  {
    id: isProdBuild ? 'b7e5f5e7-ac69-420f-a737-46aafd6ea36c' : '4ca2ec05-98e4-45eb-b3be-f90951a83e08',
    versions: ['Original', 'ServiceAB'],
  },
  {
    id: isProdBuild ? '18b2f2df-e215-4e29-8b8d-dcebd8bd7862' : '9af001eb-1b4e-4371-a971-c60a984a2c51',
    versions: ['Original', 'ReviewsAB'],
  },
];
